export default "__VITE_ASSET__B6GfyIke__"